import { render } from "./PersonDetails.vue?vue&type=template&id=444f620e"
import script from "./PersonDetails.vue?vue&type=script&lang=js"
export * from "./PersonDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__